import { SeverityLevel } from "@microsoft/applicationinsights-common"
import { appInsights, isLocalOnlyLogging } from "./ApplicationInsightsService"

const formatForAppInsights = (...args: unknown[]): string => {
  return args
    .map((arg) => (typeof arg === "object" ? JSON.stringify(arg) : arg))
    .join(" ")
}

const traceInfo = (...args: unknown[]) => {
  if (isLocalOnlyLogging()) {
    console.info(...args)
    return
  } else {
    appInsights.trackTrace({
      message: formatForAppInsights(...args),
      severityLevel: SeverityLevel.Information,
    })
  }
}

const traceWarning = (...args: unknown[]) => {
  if (isLocalOnlyLogging()) {
    console.log(...args)
    return
  } else {
    appInsights.trackTrace({
      message: formatForAppInsights(...args),
      severityLevel: SeverityLevel.Warning,
    })
  }
}

const traceError = (...args: unknown[]) => {
  if (isLocalOnlyLogging()) {
    console.error(...args)
    return
  } else {
    appInsights.trackTrace({
      message: formatForAppInsights(...args),
      severityLevel: SeverityLevel.Error,
    })
  }
}

const exception = (error: Error) => {
  if (isLocalOnlyLogging()) {
    console.error(error)
    return
  } else {
    appInsights.trackException({ exception: error })
  }
}

const event = (name: string, ...properties: unknown[]) => {
  if (isLocalOnlyLogging()) {
    console.log(name, ...properties)
    return
  } else {
    appInsights.trackEvent(
      { name },
      { properties: formatForAppInsights(...properties) },
    )
  }
}

export default {
  traceInfo,
  traceWarning,
  traceError,
  event,
  exception,
}
